import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: '',
  message: '',
  code: null,
  alert: false,
}
export const statusSlice = createSlice({
  name: 'status',
  initialState: initialState,
  reducers: {
    setSuccess: (state, {payload:{ status, message }}) => {

      state.alert = true;
      state.type = 'success';
      state.message = message;
      state.code = status;
    },
    setError: (state, {payload:{ status, message }}) => {
      state.alert = true
      state.type = 'error'
      state.message = message
      state.code = status
    },
    resetStatusState: (state) => {
      return initialState
    }
  }
})

export const { setError, resetStatusState, setSuccess } = statusSlice.actions